"use strict";
var import_vitest = require("vitest");
var import_getRoutes = require("./getRoutes");
var import_sitemap = require("./sitemap");
var import_testing_utils = require("../testing-utils");
(0, import_vitest.describe)("getSitemap", function() {
  (0, import_vitest.it)("maps the route tree to a public sitemap shape", function() {
    var routes = (0, import_getRoutes.getRoutes)((0, import_testing_utils.getMockContext)([
      "_layout.tsx",
      "index.tsx",
      "(app)/_layout.tsx",
      "(app)/thread/[id].tsx",
      "docs/[...slug].tsx"
    ]));
    var sitemap = (0, import_sitemap.getSitemap)(routes);
    (0, import_vitest.expect)(sitemap).toMatchObject({
      contextKey: "./_layout.tsx",
      href: "/",
      isInternal: false,
      isGenerated: false,
      children: import_vitest.expect.arrayContaining([
        import_vitest.expect.objectContaining({
          contextKey: "./index.tsx",
          filename: "index",
          href: "/"
        }),
        import_vitest.expect.objectContaining({
          contextKey: "./(app)/_layout.tsx",
          filename: "(app)/_layout",
          href: "/(app)",
          children: import_vitest.expect.arrayContaining([
            import_vitest.expect.objectContaining({
              contextKey: "./(app)/thread/[id].tsx",
              filename: "thread/[id]",
              href: "/(app)/thread/[id]"
            })
          ])
        }),
        import_vitest.expect.objectContaining({
          contextKey: "./docs/[...slug].tsx",
          filename: "docs/[...slug]",
          href: "/docs/[...slug]"
        })
      ])
    });
  });
});
//# sourceMappingURL=sitemap.test.js.map
